jQuery(document).ready(function($) {
    $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        data: {
            action: 'get_user_cart',
            security: (typeof decolegnoAjax !== 'undefined' && decolegnoAjax.nonce) ? decolegnoAjax.nonce : ''
        },
        success: function(response) {
            if (response.success) {

                // Update cart items count
                var cartItemsCount = response.data.cart_items_count;

                if (cartItemsCount > 0) {
                    $('.cart-count').text((cartItemsCount > 99) ? '99+' : cartItemsCount);
                    $('.icon-cart-open').addClass('cart-count--active');
                }
            } else {
                console.log('Error: ' + response.data);
            }
        },
        error: function() {
            console.log('Error fetching user data');
        }
    });
});
